import { clientPostWrapper, clientStreamingGetWrapper } from "../api/Api";
import { GET_ALL_LCW_USERS_STREAM, GET_LCW_FORM_PDF_URL, UPDATE_LCW_USER_REVIEW_STATE } from "../common/constants/routes";


export const getAllLCWUsersStream = async (onUser, onComplete, onError, options = {}) => {
    const { minFollowers = 500, maxFollowers = 10000, startDate, endDate, signal = null } = options;

    const params = {
        minFollowers,
        maxFollowers
    };

    // Add date filters if provided
    if (startDate) {
        params.startDate = startDate;
    }
    if (endDate) {
        params.endDate = endDate;
    }

    try {
        const response = await clientStreamingGetWrapper(GET_ALL_LCW_USERS_STREAM, params, signal);

        if (!response.ok) {
            throw new Error('Stream request failed');
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
            // Check if aborted before reading
            if (signal?.aborted) {
                reader.cancel();
                return;
            }

            const { done, value } = await reader.read();

            if (done) {
                // Process any remaining data in buffer
                if (buffer.trim()) {
                    try {
                        onUser(JSON.parse(buffer));
                    } catch (e) {
                        console.error('Error parsing final buffer:', e);
                    }
                }
                onComplete();
                break;
            }

            buffer += decoder.decode(value, { stream: true });

            // Split by newlines (NDJSON format)
            const lines = buffer.split('\n');
            buffer = lines.pop(); // Keep incomplete line in buffer

            for (const line of lines) {
                if (line.trim()) {
                    try {
                        const user = JSON.parse(line);
                        onUser(user);
                    } catch (e) {
                        console.error('Error parsing line:', e);
                    }
                }
            }
        }
    } catch (error) {
        // Don't call onError if the request was aborted intentionally
        if (error.name === 'AbortError') {
            console.log('Stream request was cancelled');
            return;
        }
        onError(error);
    }
}


export const updateLCWUserReviewState = (payload) => {
    return clientPostWrapper(UPDATE_LCW_USER_REVIEW_STATE, payload);
}

export const getLCWKvkkFormUrl = () => {
    return clientPostWrapper(GET_LCW_FORM_PDF_URL);
}
